import { APIResultCount } from '../../../constant'
import { useGetAdminSuppliers } from '../../../api/supplier'
import { GlobalDocumentContainer } from './GlobalDocumentContainer'
import { CenteredSpinner } from '../../../components/Spinner'
import { GlobalDocumentType } from 'src/enums'

export const GlobalDocumentAdminContainer: React.FC = () => {
  const { data: adminSuppliers, isLoading: adminSuppliersLoading } = useGetAdminSuppliers(
    0,
    APIResultCount.Max,
    true,
    true,
  )

  if (adminSuppliersLoading) {
    return <CenteredSpinner />
  }
  return (
    <GlobalDocumentContainer
      adminSuppliers={adminSuppliers}
      isSuperAdmin={true}
      globalDocumentType={GlobalDocumentType.Equipment}
    />
  )
}
